import { API } from "aws-amplify";
import "../../../configureAmplify";

export default async function getContractPublic(cid: number) {
  const queryAWSRefreshCredentials = `query MyQuery {
    getContractPublic(cid: ${cid}) {
      contract {
        cidaddr
        gparam
        cparam0
        num
        cparam1
        cparam2
        cparam3
        expiresnap
        image
      }
      event {
        eventwebsite
        eventdescription
      }
      object {
        symbol
        exchange
        cik
        companyname
        sector
        industry
        stylev
        styleh
        objectdescription
        objectwebsite
      }
      stats {
        snap
        goptin
        gprize
      }
      participants {
        addr
        snap
        tid
        estimate1
        estimate2
        estimate3
        wager
        return
        description
        research
      }
      result {
        true_value_1
        true_value_2
        true_value_3
        decode
        payout
      }
    }
  }`;

  const aws_data = await API.graphql({ query: queryAWSRefreshCredentials });
  // @ts-expect-error
  const data = { ...aws_data.data.getContractPublic, local: [] };
  return data;
}
